<!DOCTYPE HTML>
<template>
<div class="average_rates shadow">
  <div>
    <h1>Average rate by other users</h1>
    <h2 v-if="avg">Your average is ${{avg}}</h2>
  </div>
  <div class="bars">
    <div v-for="rate in rates"
         class="bar"
         :style="{height: normalize(rate.sum)+'px'}"
         :key="rate.id"
         :class="{'match': rate.rate == avg}">
      <div class="rate">${{rate.rate}}</div>
    </div>
  </div>

</div>
</template>

<script>
export default {
  name: 'AverageRates',
  props: {
    avg: Number
  },
  computed: {
    min() {
      let vals = this.rates.map( r => r.sum )
      return Math.min( ...vals )
    },
    max() {
      let vals = this.rates.map( r => r.sum )
      return Math.max( ...vals )
    }
  },
  methods: {
    normalize( v ) {
      let normed = ( v - this.min ) / ( this.max - this.min )
      return 100 * normed
    }
  },
  data() {
    return {
      rates: [
        { rate: 100, sum: 15 },
        { rate: 110, sum: 25 },
        { rate: 120, sum: 60 },
        { rate: 130, sum: 95 },
        { rate: 140, sum: 80 },
        { rate: 150, sum: 112 },
        { rate: 160, sum: 166 },
        { rate: 170, sum: 148 },
        { rate: 180, sum: 103 },
        { rate: 190, sum: 97 },
        { rate: 200, sum: 74 },
        { rate: 210, sum: 37 },
        { rate: 220, sum: 66 },
        { rate: 230, sum: 44 },
        { rate: 240, sum: 72 },
        { rate: 250, sum: 95 },
        { rate: 260, sum: 85 },
        { rate: 270, sum: 58 },
        { rate: 280, sum: 42 },
        { rate: 290, sum: 33 },
        { rate: 300, sum: 11 }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/styles/global.scss";

.average_rates {
    display: grid;
    padding: 3rem;
    border-radius: 0.5rem;
    text-align: center;
    grid-template-rows: 4rem 10rem;
    background: white;

    h1 {
        font-size: 0.7rem !important;
        text-transform: uppercase;
        letter-spacing: 0.1rem;
    }

    h2 {
        font-size: 1.2rem !important;
        color: theme-color-level('success',1);
    }

    .bars {
        height: 100px;
        display: grid;
        grid-auto-flow: column;
        grid-column-gap: 0.1rem;
        align-items: flex-end;
        align-self: center;

        .bar {
            cursor: pointer;
            position: relative;
            z-index: 1;
            background: theme-color-level('primary', -11);
            color: theme-color-level('primary', 3);

            .rate {
                display: none;
            }

            &.match {
                background: $success;
            }

            &:hover {
                background: theme-color-level('primary', 1);
                color: theme-color-level('primary', 3);
                z-index: 1000;
            }

            &:hover .rate {
                position: absolute;
                top: -1.5rem;
                text-align: center;
                display: block;
                font-size: 0.8rem;
            }
        }
    }
}
</style>
